import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const dutiesApi = createApi({
  reducerPath: 'dutiesApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Duties'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getDuties: builder.query({
      query: () => ({
        url: '/responder/duties',
      }),
      providesTags: ['Duties'], // Tells RTK Query this query provides 'Duties' data and to refetch when invalidated
    }),
    createDuty: builder.mutation({
      query: (duty) => ({
        url: '/responder/duties',
        method: 'POST',
        data: duty,
      }),
      invalidatesTags: ['Duties'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    updateDuty: builder.mutation({
      query: (duty) => ({
        url: `/responder/duties/${duty.id}`,
        method: 'PUT',
        data: duty,
      }),
      invalidatesTags: ['Duties'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    deleteDuty: builder.mutation({
      query: (id) => ({
        url: `/responder/duties/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Duties'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useGetDutiesQuery,
  useCreateDutyMutation,
  useUpdateDutyMutation,
  useDeleteDutyMutation,
} = dutiesApi;
